export const STATUSES = {
  SUCCEEDED: 'SUCCEEDED',
  REFUNDED: 'REFUNDED',
  PARTIALLY_REFUNDED: 'PARTIALLY_REFUNDED',
  REFUND_PENDING: 'REFUND_PENDING',
  REFUND_FAILED: 'REFUND_FAILED',
  FAILED: 'FAILED',
};

export const PAYMENT_TYPES = {
  ALL: 'ALL',
  ORDER: 'ORDER',
  GIFTCARD_PURCHASE: 'GIFTCARD_PURCHASE',
  GIFTCARD_ADD_FUNDS: 'GIFTCARD_ADD_FUNDS',
  SCAN_TO_PAY: 'SCAN_TO_PAY',
};
